module.exports = new __parcel__URL__("help_channel_image.12f2c7c0.png").toString();